module.exports = __webpack_public_path__ + "static/media/anuncio.dc6b84ca.jpg";